import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../../../../helper/firebase.config';
import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/Star';
import { useAuth } from '../../../../../helper/hooks/useAuth';

const UserMenu = ({ user, anchorElUser, handleCloseUserMenu, getUserInitial }) => {
  const { credits } = useAuth();
  const menuItems = [
    {
      name: `Credits ${credits !== null ? `${credits}` : ''}`,
      icon: StarIcon,
      route: '/plan'
    },
    {
      name: 'Logout',
      icon: LogoutOutlinedIcon,
      action: () => signOut(auth)
    }
  ];

  const navigate = useNavigate();
  return (
    <>
      <Menu
        sx={{ mt: '45px', zIndex: 5002 }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}>
        <Box sx={{ p: 1.5 }}>
          <Box
            sx={{
              px: 2.5,
              py: 1.5,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              borderRadius: '12px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 0.5,
              backdropFilter: 'blur(10px)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
            <Avatar
              alt={user?.displayName || user?.email || 'User'}
              src={user?.photoURL}
              sx={{ width: 48, height: 48, mb: 0.5 }}>
              {!user?.photoURL && getUserInitial()}
            </Avatar>
            <Typography sx={{ fontWeight: 600, fontSize: '14px', color: 'var(--gray-darkest)' }}>
              {user?.displayName || 'User'}
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#666' }}>{user?.email}</Typography>
          </Box>
        </Box>
        <Divider />
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <MenuItem
              key={item.name}
              onClick={() => {
                handleCloseUserMenu();
                if (item.route) {
                  localStorage.setItem('dashboardActiveTab', item.route.replace('/', ''));
                  navigate(item.route);
                }
                if (item.action) {
                  item.action();
                }
              }}
              sx={{ py: 1.5 }}>
              <ListItemIcon>
                <Icon fontSize="small" />
              </ListItemIcon>
              <Typography>{item.name}</Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default UserMenu;
